import React from "react";
import PropTypes from "prop-types";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = theme => ({
  breadcrumbsItem: {
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline"
    },
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.common.black,
  },
  labelText: {
    fontFamily: theme.typography.brand.fontFamily,
    fontWeight: theme.typography.fontWeightBold,
  }
});

const formatPageNameAsBreadcrumb = pageName => {
  const maxBreadCrumbNameLength = 32;
  var breadCrumbPageName;
  if (pageName) {
    if (typeof pageName === "object") return pageName;
    if (pageName.length > maxBreadCrumbNameLength) {
      breadCrumbPageName = `${pageName.substring(
        0,
        maxBreadCrumbNameLength
      )}...`;
    } else {
      breadCrumbPageName = pageName;
    }
  } else {
    breadCrumbPageName = "Page";
  }

  return breadCrumbPageName;
};

const OSSBreadcrumbsItem = ({ classes, label, to }) => {
  return (
    <BreadcrumbsItem to={to} className={classes.breadcrumbsItem} role="link">
      <span className={classes.labelText}>
        {formatPageNameAsBreadcrumb(label)}{" "}
      </span>
    </BreadcrumbsItem>
  );
};

OSSBreadcrumbsItem.propTypes = {
  to: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};
OSSBreadcrumbsItem.defaultProps = {
  to: "/"
};

export default withStyles(styles)(OSSBreadcrumbsItem);
